export enum DependencyOperator {
  and = 'and',
  or = 'or',
}
